module.exports = __webpack_public_path__ + "media/img/depositphotos_75937903-stock-illustration-frame-object-in-axonometric-perspective-04679720.jpg";